import ArtistCard from "@/components/ArtistCard";
import { Songcard } from "@/types";
import { Box, Center, Container, SimpleGrid } from "@chakra-ui/react";

interface ACSCardsProps {
  cards: Songcard[];
}

function ArtistCards(props: ACSCardsProps) {
  return (
    <div>
      <Container mt={5}>
        <Box position="relative" mt={5}>
          <Center></Center>
        </Box>
      </Container>
      <SimpleGrid minChildWidth="300px" spacing={5} mb={20}>
        {props.cards.map((card, index) => (
          <ArtistCard card={card} key={index} />
        ))}
      </SimpleGrid>
    </div>
  );
}

export default ArtistCards;
